export default __webpack_public_path__ + "static/media/dds5168_4p-7.9336b9b1.png";